import { TableColumn } from '@shared';
import { ReportTab } from '../interfaces';

/**
 * Playlist Tab Table Columns
 */
const PLAYLIST_TABLE_COLUMNS: TableColumn[] = [
    {
        field: 'playlistName',
        header: 'Playlist Name',
        width: '120px',
        type: 'status-copy',
    },
    {
        field: 'businessName',
        header: 'Business Name',
        width: '150px',
    },
];

/**
 * Playing Where Tab Table Columns
 */
const PLAYING_WHERE_TABLE_COLUMNS: TableColumn[] = [
    {
        field: 'playlistName',
        header: 'Playlist Name',
        width: '120px',
        type: 'status-copy',
    },
    {
        field: 'businessName',
        header: 'Business Name',
        width: '150px',
        type: 'status',
        color: '#8DCB2C',
    },
];

/**
 * History Tab Table Columns
 */
const HISTORY_TABLE_COLUMNS: TableColumn[] = [
    {
        field: 'playlistName',
        header: 'Playlist Name',
        width: '120px',
        type: 'status-copy',
    },
    {
        field: 'logAction',
        header: 'Log Action',
        width: '150px',
        type: 'status',
        color: '#8DCB2C',
    },
    {
        field: 'logUser',
        header: 'Log User',
        width: '200px',
        type: 'copy',
    },
    {
        field: 'logDate',
        header: 'Log Date',
        width: '200px',
        type: 'copy',
    },
];

/**
 * Reports card table columns
 */

export const REPORTS_CARD_TABLE_COLUMNS: TableColumn[] = [
    {
        field: 'hostName',
        header: 'Host Name',
        width: '120px',
        type: 'status-copy',
    },
    {
        field: 'playlist',
        header: 'Playlist',
        width: '150px',
        type: 'status',
        color: '#8DCB2C',
    },
    {
        field: 'totalPlay',
        header: 'Total Play',
        width: '250px',
    },
    { field: 'totalDuration', header: 'Total Duration', width: '200px' },
    { field: 'startDate', header: 'Start Date', width: '200px', type: 'copy' },
    { field: 'endDate', header: 'End Date', width: '200px', type: 'copy' },
];

/** Reports Card Tabs Constants with icon keys (iconKey here corresponds to the svg file in sprite) and its columns */
export const REPORTS_CARD_TABS: ReportTab[] = [
    {
        id: 'reports',
        label: 'Reports',
        iconKey: 'reports',
        columns: REPORTS_CARD_TABLE_COLUMNS,
    },
    {
        id: 'in-playlist',
        label: 'In Playlist',
        iconKey: 'play',
        columns: PLAYLIST_TABLE_COLUMNS,
    },
    {
        id: 'playing-where',
        label: 'Playing Where',
        iconKey: 'tv',
        columns: PLAYING_WHERE_TABLE_COLUMNS,
    },
    { id: 'history', label: 'History', iconKey: 'clock', columns: HISTORY_TABLE_COLUMNS },
];

/**
 * Sample reports data
 */
export const REPORTS_DATA = [
    {
        id: '1',
        playlistName: 'Playlist 1',
        businessName: 'Business 1',
    },
    {
        id: '2',
        playlistName: 'Playlist 2',
        businessName: 'Business 2',
    },
    {
        id: '3',
        playlistName: 'Playlist 3',
        businessName: 'Business 3',
    },
];
